import React, { useState } from "react"
import "./style.scss"
import { API_CONTACT_FORM_SUBMIT } from "../../api"

function HomeContactForm(props) {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [message, setMessage] = useState("")
  const [loadingFlag, setLoadingFlag] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()

    //submission here
    setLoadingFlag(true)
    let result = await API_CONTACT_FORM_SUBMIT(name, email, phone, message)
    if (result && result.data && result.data.success === 1) {
      props.setToastObj({
        heading: "Success",
        desc: "Submitted! We'll get back to you soon 😊",
        timePassed: "Just Now",
      })

      setName("")
      setEmail("")
      setPhone("")
      setMessage("")
    } else {
      props.setToastObj({
        heading: "Failure",
        desc: "Sorry! An error occurred 😐",
        timePassed: "Just Now",
      })
    }
    setLoadingFlag(false)
  }

  return (
    <div className="homeContactForm">
      <form onSubmit={e => handleSubmit(e)}>
        <div className="row">
          <div className="col-12">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="homeContact__name"
                placeholder="Name"
                required
                value={name}
                onChange={e => setName(e.target.value)}
              />
              <label htmlFor="homeContact__name">Name</label>
            </div>
          </div>
          <div className="col-6">
            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                id="homeContact__email"
                placeholder="Email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <label htmlFor="homeContact__email">Email</label>
            </div>
          </div>
          <div className="col-6">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="homeContact__phone"
                placeholder="phone"
                value={phone}
                onChange={e => setPhone(e.target.value)}
              />
              <label htmlFor="homeContact__phone">Phone</label>
            </div>
          </div>
          <div className="col-12">
            <div className="form-floating mb-3">
              <textarea
                className="form-control"
                id="homeContact__message"
                cols="30"
                rows="10"
                placeholder="Name"
                style={{ height: "220px" }}
                required
                value={message}
                onChange={e => setMessage(e.target.value)}
              ></textarea>
              <label htmlFor="homeContact__message">Message</label>
            </div>
          </div>
          <div className="col-4">
            <input
              type="submit"
              className="btn btn-primary"
              value="Send Message 😊"
            />
          </div>
          <div className="col-2 d-flex align-items-center">
            {loadingFlag && (
              <div className="spinner-border text-white" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  )
}

export default HomeContactForm
